var map = {
	".": 13583,
	"./": 13583,
	"./DailyMotion": 38679,
	"./DailyMotion.js": 38679,
	"./Facebook": 66113,
	"./Facebook.js": 66113,
	"./FilePlayer": 72103,
	"./FilePlayer.js": 72103,
	"./Kaltura": 35759,
	"./Kaltura.js": 35759,
	"./Mixcloud": 47928,
	"./Mixcloud.js": 47928,
	"./Mux": 44875,
	"./Mux.js": 44875,
	"./SoundCloud": 40474,
	"./SoundCloud.js": 40474,
	"./Streamable": 14652,
	"./Streamable.js": 14652,
	"./Twitch": 51939,
	"./Twitch.js": 51939,
	"./Vidyard": 32808,
	"./Vidyard.js": 32808,
	"./Vimeo": 89893,
	"./Vimeo.js": 89893,
	"./Wistia": 72137,
	"./Wistia.js": 72137,
	"./YouTube": 53535,
	"./YouTube.js": 53535,
	"./index": 13583,
	"./index.js": 13583,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players": 13583,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/": 13583,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 38679,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 38679,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 66113,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 66113,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 72103,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 72103,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 35759,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 35759,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 47928,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 47928,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux": 44875,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 44875,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 40474,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 40474,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 14652,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 14652,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 51939,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 51939,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 32808,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 32808,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 89893,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 89893,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 72137,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 72137,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 53535,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 53535,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index": 13583,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index.js": 13583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85456;